/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NotificationRuleMonitorSelectionDto = {
    type: NotificationRuleMonitorSelectionDto.type;
};

export namespace NotificationRuleMonitorSelectionDto {

    export enum type {
        ALL = 'ALL',
        FILTER = 'FILTER',
    }


}
